
// Trigger stockist data sync

fetch("//farmandyard.com.au/apps/postcode/api/stockist/sync")
  .then(response => response.json())
  .then(data => {
    // Handle the response data here
    console.log(data);
  })
  .catch(error => {
    // Handle any errors that occurred during the request
    console.error("Error:", error);
  });

  
